import { IsNotEmpty, IsOptional } from 'class-validator';

import { IsEmailUnique } from 'src/models/Email/validation/isEmailUniqueValidator';
import { IsEmailNameValid } from 'src/models/validators/emailNameValidator';

export const ENDPOINT_TYPE_EMAIL = 'EMAIL';
export class EmailAddress {
  id: string;
  accountId: string;
  address: string;

  @IsNotEmpty({ message: 'Enter a valid email username.' })
  @IsEmailUnique({ message: 'Email username taken. Try another.' })
  @IsEmailNameValid()
  emailLocalPart?: string;

  @IsOptional()
  senderName?: string;

  @IsNotEmpty({ message: 'Please select a domain' })
  emailDomain?: string;

  type: string = ENDPOINT_TYPE_EMAIL;
}
